import { useSearchParams } from "react-router";

/**
 * @description Designed to make it easier to interact with URL params
 */
export default function useParamFunctions() {
  const [searchParams, setSearchParams] = useSearchParams({});

  /**
   * @description Parse a base64 string from the URL and return an object
   */
  const paramParse = (key) => {
    try {
      return searchParams.get(key) && atob(searchParams.get(key))
        ? JSON.parse(decodeURIComponent(atob(searchParams.get(key))))
        : {};
    } catch (_) {
      return {};
    }
  };

  /**
   * @description Encode an object into a base64 string
   */
  const paramEncode = (items) => (items ? btoa(encodeURIComponent(JSON.stringify(items))) : "");

  /**
   * @description Set the params by key and payload
   *
   * @param {String}  key
   * @param {Object}  payload
   * @param {Boolean} encode
   * @param {Boolean} replace  When true, we replace url instead of pushing a new state to history
   */
  const setParams = (key, payload, encode = true, replace = false) => {
    const value = paramParse(key);

    if (value === payload) return;

    const newParams = new URLSearchParams(window.location.search);
    newParams.set(key, encode ? paramEncode(payload) : payload);

    setSearchParams(newParams, { replace });
  };

  /**
   * @description Remove a specific key from the URL params
   * @param {String} key
   */
  const removeParam = (key) => {
    setSearchParams((params) => {
      params.delete(key);
      return params;
    });
  };

  return {
    setParams,
    paramParse,
    paramEncode,
    removeParam,
  };
}
